import dbPromise from '../dbPromise'

export default (to, from, next) => {
  dbPromise().then((db) => {
    let tx = db.transaction('currentJob')
    let currentStore = tx.objectStore('currentJob')
    return (currentStore.getAll())
  }).then((val) => {
    if (val.length > 0) {
      next()
    } else {
      next('/')
    }
  })
}



// WEBPACK FOOTER //
// ./src/router/CurrentJobGuard.js